/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentDocumentsUploadModalCancel: "shipment-documents-upload-modal-cancel",
  shipmentDocumentsUploadModalSubmit: "shipment-documents-upload-modal-submit",
} as const;
